import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from "react";
import { useBanner } from "../../contexts";
import { BannerButtonsInlineStyles } from ".";
import { isIE } from "../../utils";

var BannerButton = function BannerButton(_ref) {
  var inlineStyle = _ref.inlineStyle,
      type = _ref.type,
      onClick = _ref.onClick,
      children = _ref.children,
      framed = _ref.framed;

  if (type === "hide") {
    return null;
  }

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHover = _useState2[0],
      setIsHover = _useState2[1];

  var banner = useBanner();
  var individualPrivacyOpen = banner.individualPrivacyOpen,
      _banner$decision = banner.decision,
      acceptAll = _banner$decision.acceptAll,
      acceptEssentials = _banner$decision.acceptEssentials,
      acceptAllOneRowLayout = banner.bodyDesign.acceptAllOneRowLayout;
  var interactionAttr = {
    onClick: onClick,
    onMouseEnter: function onMouseEnter() {
      return setIsHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHover(false);
    }
  }; // Also create a spacing `height:10` container because `marginBottom` causes issues with `position:sticky`

  return h("div", _extends({}, type === "button" ? interactionAttr : {}, BannerButtonsInlineStyles[inlineStyle](banner, isHover, framed, // IE does not support flex with calc()
  isIE() || acceptAll === "hide" || acceptEssentials === "hide" || individualPrivacyOpen ? false : acceptAllOneRowLayout)), h("span", _extends({}, BannerButtonsInlineStyles.ellipsesText(), type === "link" ? interactionAttr : {}), children));
};

export { BannerButton };